module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regbg"
  }, [_c('ul', {
    staticClass: "regbg-ul"
  }, _vm._l((_vm.stepLists), function(item, index) {
    return _c('li', {
      staticClass: "regbg-round",
      class: {
        'active': index + 1 == _vm.step
      }
    }, [_c('div', {
      class: ['round-jt' + (index + 1)]
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2483689c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Regstepimg.vue
// module id = 861
// module chunks = 1